export const LocateUsData = [
  { name: "Federal Post Offices", id: "fed" },
  { name: "Kashmir Post Offices", id: "kashmir" },
  { name: "Gilgit Post Offices", id: "gilgit" },
  { name: "Punjab Post Offices", id: "punjab" },
  { name: "Sindh Post Offices", id: "sindh" },
  { name: "Balochistan Post Offices", id: "balochistan" },
  { name: "Khyber Pakhtunkhwa Post Offices", id: "kpk" },
];
////Fedral////
export const Federal = [
  {
    name: "Islamabad GPO",
    location: "Islamabad GPO & Its Night Post Office",
    link: "https://goo.gl/maps/GpsztkXAxRcu4MoVA",
  },
  {
    name: "Islamabad Post Office 1",
    location: "D Block Pak Sectt. Post Office",
    link: "https://goo.gl/maps/1KzF6rhtb2jtNaa86 ",
  },
  {
    name: "Islamabad Post Office 2",
    location: "P&T Complex Post Office & It's Night Post Office",
    link: "https://goo.gl/maps/Sd5sM7SE6tbY9hrL7",
  },
  {
    name: "Islamabad Post Office 3",
    location: "F-7, Markaz Post Office",
    link: " ",
  },
  {
    name: "Islamabad Post Office 4",
    location: "Shaigon Industries Post Office",
    link: "https://www.google.com/maps/search/islamabad+post+office/@33.6348545,72.9723567,12z/data=!4m2!2m1!6e2?entry=ttu",
  },
];
////Gilgit////
export const Gilgit = [
  {
    name: "Gilgit",
    location: "Gilgit GPO",
    link: "https://goo.gl/maps/Mimr8xHkFB5Va15Y9 ",
  },
];
////Kashmir////
export const Kashmir = [
  {
    name: "Muzaffarabad",
    location: "Muzaffarabad GPO",
    link: "https://goo.gl/maps/GVmE3TacYWJZXUjL9",
  },
];
////Punjab////
export const Punjab = [
  {
    name: "Attock",
    location: "Attock GPO & Its Night Post Office",
    link: " https://goo.gl/maps/ApKdZzMFcGuXtmRQ7",
  },
  {
    name: "Attok Mail Office",
    location: "Attock District Mail Office",
    link: " https://goo.gl/maps/W6U1vAupaGgGQh7S6",
  },
  {
    name: "Bahawalpur ",
    location: "Bahawalpur GPO & Its Night Post Office",
    link: " https://goo.gl/maps/2yDYR27tUSs8xvy7A",
  },
  {
    name: "Bahawalpur Mail Office",
    location: "Bahawalpur District Mail Office",
    link: "https://goo.gl/maps/JvSnQqC7p1zUE7Xq6 ",
  },
  {
    name: "Dera Ghazi Khan",
    location: "Dera Ghazi Khan GPO",
    link: " https://goo.gl/maps/shvXhgrdptUPWv3d7",
  },
  {
    name: "Faislabad GPO",
    location: "Faisalabad GPO & Its Night Post Office",
    link: " https://goo.gl/maps/WwKBRio4G1URM5uk7",
  },
  {
    name: "Faislabad Mail Office",
    location: "Faisalabad District Mail Office",
    link: " https://goo.gl/maps/SCxSr57hYNifWMoE7",
  },
  {
    name: "Gujranwala",
    location: "Gujranwala GPO & Its Night Post Office",
    link: " https://goo.gl/maps/SmUVWjXnXhTigxao8",
  },
  {
    name: "Gujranwala Post Office",
    location: "Climaxabad Post Office",
    link: "https://goo.gl/maps/rB8mwc2rNsrGLKza7 ",
  },
  {
    name: "Gujranwala Mail Office",
    location: "Gujranwala District Mail Office",
    link: " https://goo.gl/maps/sFS9XoCWKHg3fahf7 ",
  },
  {
    name: "Gujrat",
    location: "Gujrat GPO & Its Night Post Office",
    link: "https://goo.gl/maps/cRArRXdHznz9vusy8",
  },
  {
    name: "Gujrat Post Office",
    location: "Gujrat City Post Office & Its Night Post Office",
    link: "https://goo.gl/maps/PyEoKa6ceddYqq1L8",
  },
  {
    name: "Gujrat Post Office",
    location: "S.A. Fan Post Office",
    link: "https://goo.gl/maps/yfKtUsEPR75AujH87",
  },
  {
    name: "Gujrat Post Office",
    location: "Gujrat Railway Station Post Office",
    link: "https://goo.gl/maps/p8wcwFbzhebVZpQ27",
  },
  {
    name: "Gujrat Mail Office",
    location: "Gujrat District Mail Office",
    link: "https://goo.gl/maps/MXD6qrqLmciDm53D9",
  },
  {
    name: "Jhelum",
    location: "Jhelum GPO & Its Night Post Office",
    link: "https://goo.gl/maps/RtDNMKvmYh4z7kqx8",
  },
  {
    name: "Jhelum Post Office",
    location: "Jhelum City Post Office & Its Night Post Office",
    link: "https://goo.gl/maps/YRC2X55S9xsCrVit9",
  },
  {
    name: "Jhelum Mail Office",
    location: "Jhelum District Mail Office",
    link: "https://goo.gl/maps/bfXX1Ms49ouCdx7x7",
  },
  {
    name: "Kasur",
    location: "Kasur GPO",
    link: "https://goo.gl/maps/G9ZuEV8PWREbZtKT6",
  },
  {
    name: "Lahore GPO 1",
    location: "Lahore GPO & Its Night Post Office",
    link: "https://goo.gl/maps/6tMNsQY34zrRrcG47",
  },
  {
    name: "Lahore GPO 2",
    location: "Lahore Cantt GPO    ",
    link: "https://goo.gl/maps/bVsimjQhZKMe1dRh8",
  },
  {
    name: "Lahore Post Office",
    location: "Lahore Gulberg Post Office & Its Night Post Office",
    link: "https://goo.gl/maps/4JHYJ9zfrJvXcgDYA",
  },
  {
    name: "Lahore Post Office",
    location: "Lahore Rang Mahal Post Office & Its Night Post Office",
    link: "https://goo.gl/maps/inEpDdTW1yBCLfao8",
  },
  {
    name: "Lahore Post Office",
    location: "Lahore Airport Post Office & Its Night Post Office",
    link: "https://goo.gl/maps/HDgxkXP3rDXGpMrv8",
  },
  {
    name: "Lahore Post Office",
    location: "Lahore Gulberg-III Post Office",
    link: "https://goo.gl/maps/Rgi38kbPasJMiNLe9",
  },
  {
    name: "Lahore Post Office",
    location: "Allama Iqbal Town Post Office",
    link: "https://goo.gl/maps/YSgt2n6MmhkBqyVAA",
  },
  {
    name: "Lahore Post Office",
    location: "Lahore Model Town Post Office",
    link: "https://goo.gl/maps/Nu3qny4DSNev6hDw5",
  },
  {
    name: "Lahore Post Office",
    location: "Lahore Ferozepur Road Post Office",
    link: "https://goo.gl/maps/WDxcBcJSqYDJ1ByEA",
  },
  {
    name: "Lahore Post Office",
    location: "Lahore Canal Park Post Office",
    link: "https://goo.gl/maps/rdmhPdv4EPX4BDsB9",
  },
  {
    name: "Lahore Post Office",
    location: "Sh.Zayed Hospital Post Office",
    link: "https://goo.gl/maps/ggeBK7F2oDpAmpHD7",
  },
  {
    name: "Lahore Post Office",
    location: "Lahore Shahdara Bagh Post Office",
    link: "https://goo.gl/maps/QnqTw8ukzohSp4L79",
  },
  {
    name: "Lahore Post Office",
    location: "Lahore New Garden Town Post Office",
    link: "https://goo.gl/maps/6uy1SWjFcoPkY82P9",
  },
  {
    name: "Lahore Post Office",
    location: "Lahore Baghbanpura Post Office",
    link: "https://goo.gl/maps/pfViw8nQVSqfmcSR7",
  },
  {
    name: "Lahore Mail Office",
    location: "Lahore District Mail Office",
    link: "https://goo.gl/maps/s6qn2uyx235JiSr78",
  },
  {
    name: "Multan",
    location: "Multan GPO & Its Night Post Office",
    link: "https://goo.gl/maps/gEkDr3iK5rutFhNh9",
  },
  {
    name: "Multan Mail Office",
    location: "Multan District Mail Office",
    link: "https://goo.gl/maps/B5kHKh2NPDiPUZXr8",
  },
  {
    name: "Rahim Yar Khan GPO",
    location: "Rahim Yar Khan GPO & Its Night Post Office",
    link: "https://goo.gl/maps/YjNyGt8wKPdkU6Nh9",
  },
  {
    name: "Rawalpindi GPO ",
    location: "Rawalpindi GPO & Its Night Post Office",
    link: "  https://goo.gl/maps/zwZ93zYsNfG536AP6",
  },
  {
    name: "Rawalpindi Post Office",
    location: "Rawalpindi Satillite Town Post Office & Its Night Post Office",
    link: "  https://goo.gl/maps/wNAHeqtNzniG3Uvt7",
  },
  {
    name: "Rawalpindi Post Office",
    location:
      "Islamabad International Airport Post Office & Its Night Post Office",
    link: "https://www.google.com/maps/search/rawalpindi+gpo/@33.6461472,73.0214337,13z/data=!3m1!4b1?entry=ttu",
  },
  {
    name: "Rawalpindi Post Office",
    location: "Dr.Aziz Mohammad Road Post Office",
    link: "https://www.google.com/maps/search/rawalpindi+gpo/@33.6461472,73.0214337,13z/data=!3m1!4b1?entry=ttu",
  },
  {
    name: "Rawalpindi Post Office",
    location: "Urdu Bazar Post Office & Its Night Post Office",
    link: " https://goo.gl/maps/HszyDEQxReLzQZRC7 ",
  },
  {
    name: "Rawalpindi Post Office",
    location: "Peer Waddhi Post Office",
    link: "https://goo.gl/maps/ybjYyWa4fh7UHfb17",
  },
  {
    name: " Sahiwal GPO",
    location: " Sahiwal GPO & Its Night Post Office",
    link: " https://goo.gl/maps/KHJCGjRCABdqXeBs8 ",
  },
  {
    name: "Sahiwal Post Office",
    location: "Sahiwal City Post Office & Its Night Post Office",
    link: " https://goo.gl/maps/2VEG2D7P8EgPuM2j7",
  },
  {
    name: "Sahiwal Mail Office",
    location: "Sahiwal District Mail Office",
    link: "  https://goo.gl/maps/dxVqXZEa4QcvTRpv6",
  },
  {
    name: "Sargodha GPO",
    location: "Sargodha GPO & Its Night Post Office",
    link: " https://goo.gl/maps/MJxo7K71TSQGVo2F6 ",
  },
  {
    name: "Sarghoda Post Office",
    location: "Sarghoda City Post Office & Its Night Post Office",
    link: " https://goo.gl/maps/KZni6qsQt9u8yU5m8 ",
  },
  {
    name: "Sarghoda Post Office",
    location: " Sarghoda Satellite Town Post Office & Its Night Post Office",
    link: " https://goo.gl/maps/qhsWWCfMzJLHCrbn8 ",
  },
  {
    name: "Sarghoda Post Office",
    location: "Azam Market Post Office",
    link: " https://goo.gl/maps/pEENVXomr1ajQJeH8  ",
  },
  {
    name: "Sarghoda Mail Office",
    location: "S.T. Mill Post Office",
    link: " https://goo.gl/maps/tg26iVjwp5WFQXst6 ",
  },
  {
    name: "Sialkot GPO",
    location: "Sialkot GPO & Its Night Post Office",
    link: "  https://goo.gl/maps/cuJy9hNC9n9Fnxaq5",
  },
  {
    name: "Sialkot Post Office",
    location: "Sialkot Sadar Bazar Post Office & Its Night Post Office",
    link: "https://goo.gl/maps/8fBBg5dmRSNo6NbK7  ",
  },
  {
    name: "Sialkot Mail Office",
    location: "Sialkot District Mail Office",
    link: " https://goo.gl/maps/3yt1sPUmnmxPJtiq9 ",
  },
  {
    name: "Taxila",
    location: "Taxila Post Office",
    link: " https://goo.gl/maps/3iDU8s4pX8fwzrfE9 ",
  },
  {
    name: "Toba Tek Sing",
    location: "Toba Tek Sing Post Office",
    link: " https://goo.gl/maps/ZbocKENLW4mqupdq6  ",
  },
  {
    name: "Wah Post Office",
    location: "Wah Cantt Post Office",
    link: "  https://goo.gl/maps/ysotXmP4JAKtySfp6",
  },
];
////Sindh////
export const Sindh = [
  {
    name: "Hala",
    location: "Hala Post Office",
    link: "https://goo.gl/maps/YnmDue396yqa6aY17",
  },
  {
    name: "Hyderabad",
    location: "Hyderabad GPO & Its Night Post Office",
    link: "https://goo.gl/maps/SZW2UCe68gFZ5vkHA",
  },
  {
    name: "Hyderabad Mail Office",
    location: "Hyderabad District Mail Office",
    link: "https://goo.gl/maps/SZW2UCe68gFZ5vkHA",
  },
  {
    name: "Karachi GPO 1",
    location: "Karachi GPO & Its Night Post Office",
    link: "https://goo.gl/maps/bMi9mmjtwEF5sSn3A",
  },
  {
    name: "Karachi GPO 2",
    location: "Karachi City GPO & Its Night Post Office",
    link: "https://goo.gl/maps/kpjaQDYGTjf1iZ6b8",
  },
  {
    name: "Karachi GPO 3",
    location: "Karachi Sadar GPO & Its Night Post Office",
    link: "https://goo.gl/maps/ANrU4eLhdzD6Sh3d9",
  },
  {
    name: "Karachi GPO 4",
    location: "Karachi New Town GPO",
    link: "https://goo.gl/maps/PmqjeWbhUimHtniK6",
  },
  {
    name: "Karachi GPO 5",
    location: "Karachi Nazimabad GPO",
    link: "https://goo.gl/maps/5mUHWo8fhnJ1V8b5A",
  },
  {
    name: "Karachi GPO 6",
    location: "North Nazimabad  GPO & Its Night Post Office",
    link: "https://goo.gl/maps/FGeU95ZsFn8XCgDz9",
  },
  {
    name: "Karachi Post Office",
    location: "PECHS Block-6 Post Office  & Its Night Post Office",
    link: "https://goo.gl/maps/b22QbmmD7bWQJX5m8",
  },
  {
    name: "Karachi Post Office",
    location: "Karachi Airport Post Office",
    link: "https://goo.gl/maps/2k98QWujFUrzdAk96",
  },
  {
    name: "Karachi Post Office",
    location: "Hotel Metropole Post Office",
    link: "https://goo.gl/maps/Y9Ha4rbBpQYrRxdr6",
  },
  {
    name: "Kotri",
    location: "Kotri GPO & Its Night Post Office",
    link: "https://goo.gl/maps/iRjYBowj2kDn1LHT6",
  },
  {
    name: "Larkana",
    location: "Larkana GPO & Its Night Post Office",
    link: "https://goo.gl/maps/gXgN7qv3xfxcMqJn7",
  },
  {
    name: "Sukkar GPO ",
    location: "Sukkar GPO & Its Night Post Office",
    link: " https://goo.gl/maps/Wj99i1simQkWTkCAA ",
  },
  {
    name: "Sukkar Post Office",
    location: "Sukkar Mehran Markaz Post Office",
    link: "  https://goo.gl/maps/yydi5iesjMqMzCC3A",
  },
  {
    name: "Sukkar Mail Office",
    location: "Sukkar District Mail Office",
    link: " https://goo.gl/maps/WyYPGTt6eQToxVNb6 ",
  },
  {
    name: "Sukkar Post Office",
    location: "Sukkar H.C.M. Post Office",
    link: " https://goo.gl/maps/bUssmXYrz6JzDepa9 ",
  },
];
////KPK////
export const Khyber = [
  {
    name: "Abbotabad",
    location: "Abbotabad GPO & Its Night Post Office",
    link: " https://goo.gl/maps/g3nvdnrS5nQh6atv9",
  },
  {
    name: "Dera Ismail Khan",
    location: "Dera Ismail Khan GPO",
    link: "https://goo.gl/maps/cZw9eL6iL8a64NnZ9 ",
  },
  {
    name: "Dera Ismail Khan",
    location: "Dera Ismail Khan City Post Office",
    link: " https://goo.gl/maps/785HSrGwVRC9VX6HA",
  },
  {
    name: "Mardan",
    location: "Mardan GPO & Its Night Post Office",
    link: "https://goo.gl/maps/zgZtqS2arL4VDfd3A",
  },
  {
    name: "Peshawar",
    location: "Peshawar GPO & Its Night Post Office",
    link: "https://goo.gl/maps/feFy4sWmRSGJmY1t5",
  },
  {
    name: "Peshawar",
    location: "Peshawar University Post Office & Its Night Post Office",
    link: "https://goo.gl/maps/GVWwTmqnz8uFRV9f6",
  },
  {
    name: "Peshawar",
    location: "Peshawar Airport Post Office",
    link: "https://goo.gl/maps/bb3uNQDUFTnXL6Sz9",
  },
  {
    name: "Peshawar",
    location: "Peshawar City Post Office",
    link: "https://goo.gl/maps/N9j9QmpZibPUBsD6A",
  },
  {
    name: "Peshawar",
    location: "Peshawar District Mail Office",
    link: "https://goo.gl/maps/6cgf4faB7FrAh2rWA",
  },
];
////Baloschistan////
export const Balochistan = [
  {
    name: " Quetta Express Post ",
    location: " Quetta Express Post Service (EP Service) Day/Night",
    link: "https://www.google.com/search?q=Pakistan+Post+Quetta%0D%0A%0D%0A%0D%0Auetta&sca_esv=560901828&rlz=1C1ONGR_enPK1065PK1066&cs=1&biw=1920&bih=969&tbm=lcl&sxsrf=AB5stBikOqiyIm4twv6EnxIlPPXuhmmXVA%3A1693287387584&ei=24PtZMOoI7OqhbIPj-CUqAs&ved=0ahUKEwiDgvWJk4GBAxUzVUEAHQ8wBbUQ4dUDCAk&uact=5&oq=Pakistan+Post+Quetta%0D%0A%0D%0A%0D%0Auetta&gs_lp=Eg1nd3Mtd2l6LWxvY2FsIhxQYWtpc3RhbiBQb3N0IFF1ZXR0YQoKCnVldHRhSABQAFgAcAB4AJABAJgBAKABAKoBALgBA8gBAPgBAQ&sclient=gws-wiz-local#rlfi=hd:;si:;mv:[[30.257348299999997,67.0459823],[30.076979800000004,66.9301779]];tbs:lrf:!1m4!1u3!2m2!3m1!1e1!2m1!1e3!3sIAE,lf:1,lf_ui:4",
  },
  {
    name: "Quetta Mail Office",
    location: "Quetta District Mail Office",
    link: "https://goo.gl/maps/xNKAPNjkJ2v4spFq9",
  },
  {
    name: "Quetta Post Office",
    location: "Quetta Staff College Post Office",
    link: "https://www.google.com/search?q=Pakistan+Post+Quetta%0D%0A%0D%0A%0D%0Auetta&sca_esv=560901828&rlz=1C1ONGR_enPK1065PK1066&cs=1&biw=1920&bih=969&tbm=lcl&sxsrf=AB5stBikOqiyIm4twv6EnxIlPPXuhmmXVA%3A1693287387584&ei=24PtZMOoI7OqhbIPj-CUqAs&ved=0ahUKEwiDgvWJk4GBAxUzVUEAHQ8wBbUQ4dUDCAk&uact=5&oq=Pakistan+Post+Quetta%0D%0A%0D%0A%0D%0Auetta&gs_lp=Eg1nd3Mtd2l6LWxvY2FsIhxQYWtpc3RhbiBQb3N0IFF1ZXR0YQoKCnVldHRhSABQAFgAcAB4AJABAJgBAKABAKoBALgBA8gBAPgBAQ&sclient=gws-wiz-local#rlfi=hd:;si:;mv:[[30.257348299999997,67.0459823],[30.076979800000004,66.9301779]];tbs:lrf:!1m4!1u3!2m2!3m1!1e1!2m1!1e3!3sIAE,lf:1,lf_ui:4",
  },
  {
    name: "Quetta Post Office",
    location: "Quetta Cantt Post Office",
    link: "https://goo.gl/maps/VxYw9Adf8cxAxn5K8",
  },
  {
    name: "Quetta Post Office",
    location: "Quetta Islamabad Post Office",
    link: "https://www.google.com/search?q=Pakistan+Post+Quetta%0D%0A%0D%0A%0D%0Auetta&sca_esv=560901828&rlz=1C1ONGR_enPK1065PK1066&cs=1&biw=1920&bih=969&tbm=lcl&sxsrf=AB5stBikOqiyIm4twv6EnxIlPPXuhmmXVA%3A1693287387584&ei=24PtZMOoI7OqhbIPj-CUqAs&ved=0ahUKEwiDgvWJk4GBAxUzVUEAHQ8wBbUQ4dUDCAk&uact=5&oq=Pakistan+Post+Quetta%0D%0A%0D%0A%0D%0Auetta&gs_lp=Eg1nd3Mtd2l6LWxvY2FsIhxQYWtpc3RhbiBQb3N0IFF1ZXR0YQoKCnVldHRhSABQAFgAcAB4AJABAJgBAKABAKoBALgBA8gBAPgBAQ&sclient=gws-wiz-local#rlfi=hd:;si:;mv:[[30.257348299999997,67.0459823],[30.076979800000004,66.9301779]];tbs:lrf:!1m4!1u3!2m2!3m1!1e1!2m1!1e3!3sIAE,lf:1,lf_ui:4",
  },
  {
    name: "Quetta Post Office",
    location: "Mazan Market Post Office",
    link: "https://www.google.com/search?q=Pakistan+Post+Quetta%0D%0A%0D%0A%0D%0Auetta&sca_esv=560901828&rlz=1C1ONGR_enPK1065PK1066&cs=1&biw=1920&bih=969&tbm=lcl&sxsrf=AB5stBikOqiyIm4twv6EnxIlPPXuhmmXVA%3A1693287387584&ei=24PtZMOoI7OqhbIPj-CUqAs&ved=0ahUKEwiDgvWJk4GBAxUzVUEAHQ8wBbUQ4dUDCAk&uact=5&oq=Pakistan+Post+Quetta%0D%0A%0D%0A%0D%0Auetta&gs_lp=Eg1nd3Mtd2l6LWxvY2FsIhxQYWtpc3RhbiBQb3N0IFF1ZXR0YQoKCnVldHRhSABQAFgAcAB4AJABAJgBAKABAKoBALgBA8gBAPgBAQ&sclient=gws-wiz-local#rlfi=hd:;si:;mv:[[30.257348299999997,67.0459823],[30.076979800000004,66.9301779]];tbs:lrf:!1m4!1u3!2m2!3m1!1e1!2m1!1e3!3sIAE,lf:1,lf_ui:4",
  },
  {
    name: "Quetta Post Office",
    location: "S.S. Market Post Office",
    link: "https://goo.gl/maps/iLaEkkkgKmYUTJ9x5",
  },
  {
    name: "Quetta Post Office",
    location: "Quetta Satellite Town Post Office",
    link: "https://goo.gl/maps/wyRX7ZuxMQKNvLwy5",
  },
  {
    name: "Quetta Post Office",
    location: "Chiltan Market Post Office",
    link: "https://goo.gl/maps/gVqCu7Vta9qSbNQF6",
  },
  {
    name: "Quetta Post Office",
    location: "Quetta Bazar Post Office",
    link: "https://goo.gl/maps/up59msU7Q4HDgo3r7",
  },
  {
    name: "Quetta Post Office",
    location: "Govt. School Post Office",
    link: "https://goo.gl/maps/Bt385VEXF3HwsAZt6",
  },
];
